export const GET_RESEQUENCE_CARS = "resequence/get_resequence_cars"
export const GET_RESEQUENCE_CARS_SUCCESS =
    "resequence/get_resequence_cars_success"
export const GET_RESEQUENCE_CARS_FAILURE =
    "resequence/get_resequence_cars_failure"
export const CLEAR_RESEQUENCE_CARS = "resequence/clear_resequence_cars"
export const SAVE_RESEQUENCE_CARS = "resequence/save_resequence_cars"
export const RESEQUENCE_SUCCESS = "resequence/resequence_success"
export const RESEQUENCE_FAILURE = "resequence/resequence_failure"
export const RESEQUENCE_RESET = "resequence/resequence_reset"
